import "pixi.js";
import BaseComponent from "./BaseComponent";
import C_Entity from "../../const/C_Entity";
import Physics from "./Physics";
import C_Physics from "../../const/C_Physics";
import GameSprite from "./GameSprite";
import FlierLogic from "./FlierLogic";
import Point3D from "../math/Point3D";
import Entity from "../components/Entity";
import MathUtil from "../utils/MathUtil";
import FlierData from "../model/FlierData";
import C_Ships from "../../const/C_Ships";
import MotmPhysics from "./MotmPhysics";
import MotherOfTheMoon from "./MotherOfTheMoon";
import MotherOfTheMoonLogic from "./MotherOfTheMoonLogic";
import C_ViewType from "../../const/C_ViewType";


class EnemySpawner extends BaseComponent
{


    constructor(data)
    {
        super();
        this.deltaFactor = 1;

        this.position = data.pos;
        this.positionRange = data.range;
        this.spawnRange = data.spawnRange;
        this.objectIds = data.ids;
        this.velocityScale = data.velocityScale;
        this.velocityOffset = data.velocityOffset;
        this.angleMin = data.angleMin;
        this.angleMax = data.angleMax;

        this.startDelay = data.startDelay ? data.startDelay : 0;
        this.waveDelay = data.spawnerWaveDelay ? data.spawnerWaveDelay : 0;
        this.offDelay = data.offDelay ? data.offDelay : 0;

        this.timeToNext = Math.random() * this.offDelay + this.startDelay;
        this.fliersToSpawn = 0;

    }


    scheduleNextWave()
    {
        // this.timeToNext = 15 + Math.random() * 15 + this.waveDelay;

        this.timeToNext = this.waveDelay + Math.random()*this.offDelay;
        // this.timeToNext = this.waveDelay + Math.random()*this.offDelay + 5000;
    }


    update(delta)
    {
        this.timeToNext -= delta * this.deltaFactor;

        if (this.timeToNext <= 0 && this.fliersToSpawn == 0)
        {
            this.spawnTimer = 0;

            this.waveType = this.objectIds[MathUtil.getRandomInt(0, this.objectIds.length-1)];
            this.flierData = FlierData.byType[this.waveType];

            this.waveCircle = false;
            this.waveVertical = false;
            this.waveHorizontal = false;

            if (this.app.eFactory.getViewType() == C_ViewType.NORMAL)
            {
                if (this.waveType == 1 || this.waveType == 2)
                {
                    let rnd = Math.random();

                    if (rnd < .1)
                    {
                        this.waveCircle = true;
                    }
                    else if (rnd < .2)
                    {
                        this.waveVertical = true;
                    }
                    else if (rnd < .3)
                    {
                        this.waveHorizontal = true;
                    }

                    // for testing
                    // this.waveCircle = false;
                    // this.waveVertical = false;
                    // this.waveHorizontal = true;
                }
                else if (this.waveType == 3)
                {
                    this.waveCircle = true;
                }

                this.shootChance = this.flierData.shootChance;
            }

            this.multiplierChance = this.flierData.multiplierChance;

            this.fliersToSpawn = MathUtil.getRandomInt(this.flierData.qtyMin, this.flierData.qtyMax);
            // this.fliersToSpawn = 1;
            this.waveSize = this.flierData.size;

            // get random position (rp) from the spawner
            this.rp = MathUtil.getRandomInt(0, this.position.length - 1);

            if (this.flierData.movement == "2d")
            {
                // let totalVelocity = MathUtil.getRandomFloat(this.flierData.velMin, this.flierData.velMax);
                // let mainVel = MathUtil.getRandomFloat(this.flierData.vel3DMin.x, this.flierData.vel3DMax.x);
                // if (mainVel > totalVelocity)
                //     mainVel = totalVelocity;
                // let secondVel = Math.sqrt(totalVelocity*totalVelocity - mainVel*mainVel);
                // // for changing direction (left/right or top/bot
                // secondVel = (Math.random() < 0.5 || Math.sin(Math.PI/3) > secondVel/totalVelocity) ? secondVel : secondVel*-1;
                //
                // //test
                // mainVel = Math.cos((Math.PI/4)) * totalVelocity;
                //
                // // secondVel = Math.sqrt(totalVelocity*totalVelocity - mainVel*mainVel);
                // secondVel = Math.sin((Math.PI/4) + Math.PI) * totalVelocity;


                let totalVelocity = MathUtil.getRandomFloat(this.flierData.velMin, this.flierData.velMax);
                let randomAngle = MathUtil.getRandomFloat(this.angleMin[this.rp], this.angleMax[this.rp]);
                let xVel = Math.cos(randomAngle) * totalVelocity;
                let yVel = Math.sin(randomAngle + Math.PI) * totalVelocity; // + Math.PI because the positive Y is reversed

                this.spawnAngle = randomAngle;
                this.waveVelocity = new Point3D(
                    xVel,
                    yVel,
                    0);
            }
            else
            {
                this.waveVelocity = new Point3D(
                    -MathUtil.getRandomInt(this.flierData.vel3DMin.x, this.flierData.vel3DMax.x),
                    -MathUtil.getRandomInt(this.flierData.vel3DMin.y, this.flierData.vel3DMax.y),
                    -MathUtil.getRandomInt(this.flierData.vel3DMin.z, this.flierData.vel3DMax.z)
                );
            }

            // this.waveVelocity = new Point3D(
            //     -MathUtil.getRandomInt(this.flierData.vel3DMin.x, this.flierData.vel3DMax.x),
            //     -MathUtil.getRandomInt(this.flierData.vel3DMin.y, this.flierData.vel3DMax.y),
            //     -MathUtil.getRandomInt(this.flierData.vel3DMin.z, this.flierData.vel3DMax.z)
            // );

            this.spawnDelay = this.flierData.spawnDelay;

            // We want the whole wave to spawn from same Z position
            this.spawnZPos = this.position[this.rp].z + this.positionRange.z * (-.5 + Math.random());

            this.permanentRotation = this.flierData.permanentRotation;
        }

        if (this.fliersToSpawn > 0)
        {
            this.spawnTimer -= delta;
            if (this.spawnTimer <= 0)
            {
                this.fliersToSpawn --;

                if (this.fliersToSpawn == 0)
                {
                    this.scheduleNextWave();
                }

                this.spawnTimer = this.spawnDelay * (.9 + Math.random() * .2);

                let startX;
                let startY;
                startX = this.position[this.rp].x + this.positionRange.x * (-.5 + Math.random());
                startY = this.position[this.rp].y + this.positionRange.y * (-.5 + Math.random());

                this.spawnPt = new Point3D(startX, startY, this.spawnZPos);

                this.flierData.shipType == C_Ships.MOTHER_OF_THE_MOONS ? this.spawnMotherOfMoon() : this.spawn();
            }
        }
    }


    spawn()
    {
        let e = new Entity(C_Entity.FLIER);

        let p = new Physics();

        // let moveSpawnPos = Math.random() < .25;
        // let rndX = moveSpawnPos ? -2 + 4 * Math.random() : 0;
        // let rndY = moveSpawnPos ? -2 + 4 * Math.random() : 0;
        // let rndZ = moveSpawnPos ? -2 + 4 * Math.random() : 0;
        let rndZ = this.fliersToSpawn*.1; // We spawn all elements from 1 wave on the same Z position

        p.setSpriteRendered(false);
        // p.setPosition(this.spawnPt.x + rndX, this.spawnPt.y + rndY, this.spawnPt.z + rndZ);
        p.setPosition(this.spawnPt.x, this.spawnPt.y, this.spawnPt.z + rndZ);
        p.setVelocity(this.waveVelocity.x, this.waveVelocity.y, this.waveVelocity.z);
        p.setSize(this.waveSize);
        p.initPhysics(C_Physics.PASSIVE, this.waveSize * .5);

        let shipTextureName = "ship_" + this.waveType;
        if (this.app.eFactory.getViewType() == C_ViewType.TOP && this.waveType <= 4)
        {
            shipTextureName += "_top";
        }
        let s = new GameSprite(shipTextureName);
        s.sprite.interactive = true;
        s.sprite.flierId = e.getId();
        s.setTarget();
        if (this.flierData.animation)
        {
            s.addAnimationSprite(this.flierData.endFrame, this.flierData.animationHeight,
                this.flierData.animAnchor);
        }
        if (this.spawnAngle)
        {
            s.setSpriteRotation(this.spawnAngle);
        }
        s.fadeInTime = .5;
        if (this.flierData.overlay)
        {
            s.addBlinkOverlay(1);
        }
        if (Math.random() < this.multiplierChance)
        {
            s.setMultiplier();
        }

        let l = new FlierLogic(this.waveType);

        l.shipType = this.flierData.shipType;

        if (Math.random() < this.shootChance)
        {
            l.isShooter = true;
        }

        if (this.app.eFactory.getViewType() == C_ViewType.NORMAL)
        {
            if (this.waveType == 1 || this.waveType == 2)
            {
                if (this.waveCircle)
                {
                    p.addVelocityModifier(.6, 2, 2);
                }
                else if (this.waveVertical)
                {
                    p.addVelocityModifier(.7, 0, 2);
                }
                else if (this.waveHorizontal)
                {
                    p.addVelocityModifier(.5, 2, 0);
                }
                else
                {
                    let rotSpeed = -.05 + Math.random()*.1;
                    let rotZdistance = 250 + Math.random()*100;
                    p.setZTriggeredRotation(rotSpeed, rotZdistance);
                }
            }
            else if (this.waveType == 3)
            {
                p.addVelocityModifier(0.4, 2, 2);
            }
        }


        if (this.permanentRotation)
        {
            let rotSpeed = -.05 + Math.random() * .1;
            p.setZTriggeredRotation(rotSpeed, Number.POSITIVE_INFINITY);
        }

        if (this.velocityScale)
        {
            p.velocity.vectorScale(this.velocityScale);
        }

        if (this.velocityOffset)
        {
            p.velocity.add(this.velocityOffset);
        }

        p.setPositionLimits(this.flierData.posMin, this.flierData.posMax);

        e.addComponent(p, Physics);
        e.addComponent(s, GameSprite);
        e.addComponent(l);

        this.entitySystem.addEntity(e);
    }


    spawnMotherOfMoon()
    {
        let e = new Entity(C_Entity.FLIER);

        let p = new MotmPhysics();

        p.setSpriteRendered(false);
        p.setPosition(this.spawnPt.x, this.spawnPt.y, this.spawnPt.z);
        // p.setVelocity(this.waveVelocity.x, this.waveVelocity.y, this.waveVelocity.z);
        p.setVelocity(0, 0, 0);
        p.setSize(this.waveSize);
        p.initPhysics(C_Physics.PASSIVE, this.waveSize * .5);

        let s = new MotherOfTheMoon();
        s.getSprite().interactive = true;
        s.getSprite().flierId = e.getId();
        s.setTarget();
        s.fadeInTime = .5;

        let l = new MotherOfTheMoonLogic(this.waveType);

        l.shipType = this.flierData.shipType;

        if (Math.random() < this.shootChance)
        {
            l.isShooter = true;
        }

        if (this.velocityScale)
        {
            p.velocity.vectorScale(this.velocityScale);
        }

        if (this.velocityOffset)
        {
            p.velocity.add(this.velocityOffset);
        }


        e.addComponent(p, Physics);
        e.addComponent(s, GameSprite);
        e.addComponent(l, FlierLogic);

        this.entitySystem.addEntity(e);


        // let e = new Entity(C_Entity.FLIER);
        //
        // let p = new MotmPhysics();
        //
        // p.setSpriteRendered(false);
        // p.setPosition(this.spawnPt.x, this.spawnPt.y, this.spawnPt.z);
        // p.setVelocity(this.waveVelocity.x, this.waveVelocity.y, this.waveVelocity.z);
        // p.setSize(this.waveSize);
        // p.initPhysics(C_Physics.PASSIVE, this.waveSize * .5);
        //
        // let s = new MotherOfTheMoon("ship_22_v5");
        // s.sprite.interactive = true;
        // s.sprite.flierId = e.getId();
        // s.setTarget();
        // s.fadeInTime = .5;
        // if (this.flierData.overlay)
        // {
        //     s.addBlinkOverlay(1);
        // }
        //
        // let l = new MotherOfTheMoonLogic(this.waveType);
        //
        // l.shipType = this.flierData.shipType;
        //
        // if (Math.random() < this.shootChance)
        // {
        //     l.isShooter = true;
        // }
        //
        // // currently not used
        // p.addSpiralModifier(30, Math.PI * 4 - Math.PI/7, 15, 2);
        // p.addVelocityModifier(1.5, 0.5, 0.5);
        //
        // if (this.velocityScale)
        // {
        //     p.velocity.vectorScale(this.velocityScale);
        // }
        //
        // if (this.velocityOffset)
        // {
        //     p.velocity.add(this.velocityOffset);
        // }
        //
        //
        // e.addComponent(p, Physics);
        // e.addComponent(s, GameSprite);
        // e.addComponent(l, FlierLogic);
        //
        // this.entitySystem.addEntity(e);
    }


}


export default EnemySpawner;